import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type CardBadgeVariant = 'metric' | 'tag';
export type CardBadgeTagColor = 'green' | 'gold' | 'purple';

export interface CardBadgeConfig {
  value: string;
  iconUrl?: string;
  /** Use TranslatePipe when true (value is a translation key). */
  translateKey?: boolean;
  variant?: CardBadgeVariant;
  tagColor?: CardBadgeTagColor;
}

@Component({
  selector: 'app-card-badge',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './card-badge.component.html',
  styleUrl: './card-badge.component.scss',
})
export class CardBadgeComponent {
  value = input.required<string>();
  iconUrl = input<string>();
  translateKey = input<boolean>(false);
  variant = input<CardBadgeVariant>('metric');
  tagColor = input<CardBadgeTagColor>();
}
